// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import "babel-polyfill";
import Vue from "vue";
import Es6Promise from "es6-promise";
Es6Promise.polyfill();

import App from "./App";
import router from "./router";
import axios from "./api/http.js";

// 引入vant
import Vant from "vant";
import "vant/lib/index.css";
import "./assets/css/vant.less"; //自定义的vant的样式
//移动端的像素rem换算
import "./api/rem";
import VueAwesomeSwiper from "vue-awesome-swiper";
import "swiper/dist/css/swiper.css";
import "./api/cloud.js"; //云开发 Web SDK

import "./assets/css/reset.css"; //重置样式
import "./assets/css/common.less"; //常见公共样式
import "./assets/css/animation.css"; //动画的css文件
import Vueclipboard from "vue-clipboard2";
Vue.use(Vueclipboard);
import Vuex from "vuex";
import store from "./store/";
import VueTouch from "vue-touch";

var dsBridge = require("dsbridge");
Vue.config.ignoredElements = ["wx-open-launch-weapp"];
VueTouch.config.swipe = {
  threshold: 100 //手指左右滑动距离
};

Vue.prototype.dsBridge = dsBridge;
Vue.prototype.$http = axios;

// 监测网络变化
localStorage.setItem("netWorkStatus", "on"); //默认值
window.addEventListener("offline", () => {
  console.log("已断网");
  localStorage.setItem("netWorkStatus", "off");
  dsBridge.call("common.showToast", { content: "检测到网络异常，请检查网络" });
});
window.addEventListener("online", () => {
  console.log("网络已连接");
  localStorage.setItem("netWorkStatus", "on");
  dsBridge.call("common.showToast", { content: "网络已恢复" });
});

function GetQueryString(name) {
  var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)");
  var r = window.location.search.substr(1).match(reg);
  if (r != null) return unescape(r[2]);
  return null;
}
// 链路采集
import { apm } from "./utils/elastic";
apm.init();

// 引入封装的app调用方法
import { warn, openUrl, openPage, exit, showLoading, hideLoading } from "./utils/appFunction.js";
let osInfo = dsBridge.call("common.getOSInfo", "") || {};
let appInfo = dsBridge.call("common.getAppInfo", "") || {};
let userInfo = dsBridge.call("common.getUserInfo", "") || {};
Vue.prototype.osInfo = osInfo; //设备信息
Vue.prototype.appInfo = appInfo; //app信息
Vue.prototype.userInfo = userInfo; //用户信息
Vue.prototype.os = osInfo.device_type; //ios/android
Vue.prototype.fullScreen = osInfo.is_iphonex_type || false; //ios/android
Vue.prototype.warn = warn;
Vue.prototype.openUrl = openUrl;
Vue.prototype.openPage = openPage;
Vue.prototype.exit = exit;
Vue.prototype.showLoading = showLoading;
Vue.prototype.hideLoading = hideLoading;
// 注册左上角返回按钮--挂载全局
function backBtn(path, query) {
  if (!path) {
    dsBridge.call("common.showToast", { content: "path不能为空" });
    return;
  }
  if (!query) {
    dsBridge.call("common.showToast", { content: "query不能为空" });
    return;
  }
  dsBridge.register("onPressBackSyn", function(o, n) {
    router.push({
      path,
      query
    });
  });
}
Vue.prototype.backBtn = backBtn;

// 同时设置中间标题和右侧按钮
function setHead(text, rightText, rightIcon) {
  var headerModel = {
    title: {
      //标题文字为 标题，颜色为 #AA00AA，无图标，文字居中
      text,
      textColor: "363C54",
      icon: {
        position: "left",
        url: null
      },
      callback: "onTitle"
    },
    rightColumn: [
      {
        text: rightText, // 按钮文字
        textColor: "363C54",
        icon: {
          position: "right", // left right
          url: rightIcon
        },
        callback: "onCustom" //方法的名称
      }
    ]
  };
  dsBridge.call("common.headerSetOption", headerModel);
}
Vue.prototype.setHead = setHead;

// 注册右上角按钮功能
function rightBtn(text, icon) {
  var headerModel = {
    rightColumn: [
      {
        text, // 按钮文字
        textColor: "363C54",
        icon: {
          position: "right", // left right
          url: icon
        },
        callback: "onCustom" //方法的名称
      }
    ]
  };
  dsBridge.call("common.headerSetOption", headerModel);
}
Vue.prototype.rightBtn = rightBtn;

//与原生交互获取token
if (window.location.pathname != "/nioapp/HomeSigning") {
  dsBridge.call("common.controlBackSyn", "1");
  dsBridge.register("onPressBackSyn", function(o, n) {
    router.go(-1);
  });
}

Vue.use(Vuex);
Vue.use(Vant);
Vue.use(VueAwesomeSwiper);

/* eslint-disable no-new */
new Vue({
  el: "#app",
  store,
  router,
  components: { App },
  template: "<App/>"
});
// 全局混入滚动元素的方法
import scrollToApi from "./utils/scrollToApi.js";
Vue.mixin(scrollToApi);

//路由切换的登录判断
router.beforeEach((to, from, next) => {
  // store.commit("changeFormRouter", from.name);
  if (window.imagePreview) {
    //图片预览中
    window.imagePreview.close();
    next();
  } else {
    next();
  }
});



// WEBPACK FOOTER //
// ./src/main.js